export enum TrackingEvent {
  ShortcutUsed = 'Shortcut used',
}
